import {
  ParsedResponse,
  Payload,
  Rating,
  ResponseMessagesType,
  ResponseId,
  TextChats,
} from "../types/response.types";
import { parseMDStringToHtml } from "./parseMDStringToHtml";
import { parseMDToText } from "./parseMDToText";

export const chatApiResponseParser = (
  response: ResponseMessagesType | undefined,
  inputValue: string,
  rating?: Rating
): ParsedResponse | null => {
  if (!response) {
    return [];
  }

  const [chatAnswers, metaData, responseId]: [TextChats, Payload, ResponseId] =
    response;
  const chatAnswersText = chatAnswers?.text?.text;

  return chatAnswersText?.map((chatAnswer: string, index: number) => {
    const metaDataObj = metaData?.payload?.richContent[0][index];
    const metaDataPrepared = {
      type: metaDataObj?.type,
      title: metaDataObj?.title,
      subtitle: metaDataObj?.subtitle,
      actionLink: metaDataObj?.actionLink,
      responseId: responseId?.responseId,
    };

    return {
      chatAnswerPlainText: parseMDToText(chatAnswer),
      chatAnswer: parseMDStringToHtml(chatAnswer),
      query: inputValue,
      rating: rating || null,
      ...metaDataPrepared,
    };
  });
};
